import type { Effect, Reducer } from 'umi';
import { getUserPage, sendButie, editRemark, addUser, editUser, removeUser } from './service';
import type { SingleUserType } from './data';

export type UserModelState = {
  items: SingleUserType[];
  total: number;
  current: number;
  pageSize: number;
};

export type UserModelType = {
  namespace: 'user';
  state: UserModelState;
  effects: {
    fetchUserPageEffect: Effect;
    refreshDataEffect: Effect;
    sendButieEffect: Effect;
    editRemarkEffect: Effect;
    addUserEffect: Effect;
    editUserEffect: Effect;
    removeUserEffect: Effect;
  };
  reducers: {
    setUserPage: Reducer<UserModelState>;
  };
};

const UserModel: UserModelType = {
  namespace: 'user',

  state: {
    items: [],
    total: 0,
    current: 1,
    pageSize: 20,
  },

  effects: {
    *fetchUserPageEffect({ payload }, { call, put }) {
      const response = yield call(getUserPage, payload);
      if (response.code === 0) {
        yield put({
          type: 'setUserPage',
          payload: response.data,
        });
      }
      return response;
    },

    *refreshDataEffect({ payload }, { call }) {
      const response = yield call(getUserPage, payload);
      return response;
    },

    *sendButieEffect({ payload, callback }, { call, put }) {
      const response = yield call(sendButie, payload.values);
      if (response.code === 0) {
        yield put({
          type: 'fetchUserPageEffect',
          payload: {
            current: payload.current,
            pageSize: payload.pageSize,
            filter: payload.filter,
            sorter: payload.sorter,
          },
        });
      }
      if (callback) callback(response);
      return response;
    },

    *editRemarkEffect({ payload, callback }, { call, put }) {
      const response = yield call(editRemark, payload.values);
      if (response.code === 0) {
        yield put({
          type: 'fetchUserPageEffect',
          payload: {
            current: payload.current,
            pageSize: payload.pageSize,
            filter: payload.filter,
            sorter: payload.sorter,
          },
        });
      }
      if (callback) callback(response);
      return response;
    },

    *addUserEffect({ payload, callback }, { call, put }) {
      const response = yield call(addUser, payload.values);
      if (response.code === 0) {
        yield put({
          type: 'fetchUserPageEffect',
          payload: {
            current: payload.current,
            pageSize: payload.pageSize,
            filter: payload.filter,
            sorter: payload.sorter,
          },
        });
      }
      if (callback) callback(response);
      return response;
    },

    *editUserEffect({ payload, callback }, { call, put }) {
      const response = yield call(editUser, payload.values);
      if (response.code === 0) {
        yield put({
          type: 'fetchUserPageEffect',
          payload: {
            current: payload.current,
            pageSize: payload.pageSize,
            filter: payload.filter,
            sorter: payload.sorter,
          },
        });
      }
      if (callback) callback(response);
      return response;
    },

    *removeUserEffect({ payload, callback }, { call, put }) {
      const response = yield call(removeUser, payload.values);
      if (response.code === 0) {
        yield put({
          type: 'fetchUserPageEffect',
          payload: {
            current: payload.current,
            pageSize: payload.pageSize,
            filter: payload.filter,
            sorter: payload.sorter,
          },
        });
      }
      if (callback) callback(response);
      return response;
    },
  },

  reducers: {
    setUserPage(state, action) {
      return {
        ...state,
        items: action.payload.items || [],
        total: action.payload.total || 0,
        current: action.payload.current || 1,
        pageSize: action.payload.pageSize || 20,
      };
    },
  },
};

export default UserModel;
